export default __webpack_public_path__ + "static/media/flag-es.2a3e1919.svg";